import React from "react";
import { FACT_SOURCE_META } from "../../lib/constants";
import { cn } from "../../lib/utils";

/**
 * FactChip — visual label for the origin of a piece of information.
 *
 * Phase 5 uses: SOURCE_FACT | CALCULATED | FINDING
 * Phase 6 will add: INFERRED | RECOMMENDED (already defined in constants).
 *
 * ```jsx
 * <FactChip source="SOURCE_FACT" />
 * <FactChip source="CALCULATED" size="sm" />
 * ```
 */
export function FactChip({ source, size = "sm", className, "data-testid": testId }) {
  const meta = FACT_SOURCE_META[source];
  if (!meta) return null;
  return (
    <span
      role="note"
      aria-label={meta.aria}
      data-testid={testId || `fact-chip-${source.toLowerCase()}`}
      className={cn(
        "inline-flex items-center rounded font-mono uppercase tracking-wide",
        size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5",
        meta.bg, meta.text,
        className,
      )}
    >
      {meta.label}
    </span>
  );
}
